import { IWidgetLoader } from '@ispm/widgets/interfaces/widget-loader.interface';
import { IDynamicFormPayload } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';

export interface IAnalyticsChartsConfig extends IWidgetLoader, IDynamicFormPayload {
  header: string;
  data: Array<IAnalyticsChartsConfigItem>;
}

export interface IAnalyticsChartsConfigItem {
  colId: string;
  colHeader: string;
  chartType: string;
  colorsPallet?: Array<String>;
  sortOrder?: string;
  verticalMode?: boolean;       // in Bar chart, set if the categories will be presented vertically (x-axis) or horizontally (y-axis)
  scaleValuesSize?: number;     // in Bar chart, set the number of ticks to present in the values scale
  scaleValuesRangeMin?: number; // in Bar chart, set the values scale's min range
  scaleValuesRangeMax?: number; // in Bar chart, set the values scale's max range
  categoriesSize?: number;      // set the number of categories to present
  categoriesRangeMin?: number;  // in Bar chart, set the scale's min range (Numeric data type only)
  categoriesRangeMax?: number;  // in Bar chart, set the scale's max range (Numeric data type only)
  categoriesIncrement?: number; // in Bar chart, set the value by which range is increments (Numeric data type only)
  categories?: Array<any>;      // in Bar chart, specify the specific categories to present:
                                //  (*) in Numeric data type, values refer to the lower-bound of the category
                                //  (*) in Category data type, values refer to category's label. Non-specified labels will e added to 'Others' category
}

export enum AnalyticsChartType {
  pie = "pie",
  bar = "bar",
  donut = "donut",
};

/* it is important to keep the values as they are used in the sorting mechanism */
export enum AnalyticsChartSortOrder {
  asc = -1,
  desc = 1,
  none = 0
};

